import { Artist } from "./Show";
import type { PagyMetadata } from "@/components/pagination/PaginationControls";
import PaginationControls from "@/components/pagination/PaginationControls";
import PageHeader from "@/components/PageHeader";
import DataTable, { DataTableColumn } from "@/components/DataTable";
import { PageWithLayout, wideLayout } from "@/components/Layout";

interface IndexProps {
  artists: Artist[];
  pagy: PagyMetadata;
}

const columns: DataTableColumn<Artist>[] = [
  {
    label: "Name",
    minWidth: "min-w-64",
    cellClassName: "font-medium",
    render: (artist) => artist.name,
  },
  {
    label: "Created At",
    minWidth: "min-w-32",
    cellClassName: "font-light",
    render: (artist) => new Date(artist.created_at).toLocaleDateString(),
  },
];

const Index: PageWithLayout<IndexProps> = ({ artists, pagy }) => {
  return (
    <div className="flex w-full flex-col items-start justify-start gap-10">
      <PageHeader
        title="All artists"
        primaryAction={{ href: "/artists/new", text: "New Artist" }}
      />
      <div className="flex w-full flex-col items-start justify-start gap-5">
        <DataTable
          columns={columns}
          rows={artists}
          rowKey={(artist) => artist.id}
          rowHref={(artist) => `/artists/${artist.id}`}
        />
        <PaginationControls {...pagy} />
      </div>
    </div>
  );
};

Index.layout = wideLayout;

export default Index;
